<p-table
  #dt1
  [value]="data?.workers"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]=""
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false"
>
  <ng-template pTemplate="caption">
    <div [formGroup]="form" class="page-control flex align-items-start">
      <div class="grid w-100">
        <div
          class="col-12 flex justify-content-between mb-2 align-items-center"
        >
          <h2 class="text-black-alpha-90">Dnevni izveštaj</h2>

          <div class="flex">
            <button
              class="main-btn"
              [disabled]="!form.valid || data.length == 0"
              (click)="onExportPdf()"
              [ngClass]="{ disabled: !form.valid || data.length == 0 }"
            >
              Export PDF <i class="pi pi-file-pdf"></i>
            </button>
          </div>
        </div>
        <div class="col-4">
          <div class="field w-100 mb-0">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar"
              placeholder="Datum "
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date"
            ></p-calendar>
          </div>
        </div>
        <div class="col-4">
          <button
            class="clear-btn"
            (click)="clearFilters()"
            pTooltip="Obriši filter"
            tooltipPosition="top"
          >
            <i class="pi pi-times m-0"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-worker>
    <tr>
      <th>
        <span>Ime i prezime </span>
      </th>
      <th>
        <span>Datum</span>
      </th>

      <th>
        <span>Prijava</span>
      </th>
      <th>
        <span>Odjava</span>
      </th>
      <th>
        <span>R. vreme</span>
      </th>
      <th class="work w-7rem">
        <span>Rad</span>
      </th>
      <th class="pause w-7rem">
        <span>Pauza</span>
      </th>
      <th class="off w-7rem">
        <span>Odjavljen</span>
      </th>
      <th class="work w-7rem">
        <span>Rad</span>
      </th>
      <th class="pause w-7rem">
        <span>Pauza</span>
      </th>
      <th class="off w-7rem">
        <span>Odjavljen</span>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-worker>
    <tr>
      <td>
        <span>{{ worker?.fullname }}</span>
      </td>
      <td>
        <span>{{ worker?.date }}</span>
      </td>
      <td>
        <span>{{ worker?.startWorkTime ? worker?.startWorkTime : "-" }}</span>
      </td>
      <td>
        <span>{{ worker?.endWorkTime ? worker?.endWorkTime : "-" }}</span>
      </td>
      <td>
        <span>{{ worker?.totalShiftTime }}</span>
      </td>
      <td class="work w-7rem">
        <span>{{ worker?.totalWorkTime }}</span>
      </td>
      <td class="pause w-7rem">
        <span>{{ worker?.totalBreakTime }}</span>
      </td>
      <td class="off w-7rem">
        <span>{{ worker?.totalLogoutTime }}</span>
      </td>
      <td class="work w-7rem">
        <span>{{ worker?.totalWorkTimePercent }}%</span>
      </td>
      <td class="pause w-7rem">
        <span>{{ worker?.totalBreakTimePercent }}%</span>
      </td>
      <td class="off w-7rem">
        <span>{{ worker?.totalLogoutTimePercent }}%</span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>
</p-table>

<div class="mt-4">
  <p-table
    #dt1
    [value]="workScore"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [loading]=""
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
  >
    <ng-template pTemplate="header" let-score>
      <tr>
        <th>
          <span></span>
        </th>
        <th>
          <span>Datum</span>
        </th>
        <th>
          <span>Prijava</span>
        </th>
        <th>
          <span>Odjava</span>
        </th>
        <th>
          <span>R. vreme</span>
        </th>
        <th class="work w-7rem">
          <span>Rad</span>
        </th>
        <th class="pause w-7rem">
          <span>Pauza</span>
        </th>
        <th class="off w-7rem">
          <span>Odjavljen</span>
        </th>
        <th class="work w-7rem">
          <span>Rad</span>
        </th>
        <th class="pause w-7rem">
          <span>Pauza</span>
        </th>
        <th class="off w-7rem">
          <span>Odjavljen</span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-score>
      <tr>
        <td>
          <span>{{ score?.header }}</span>
        </td>
        <td>
          <span>{{ score?.date }}</span>
        </td>
        <td>
          <span>{{ score?.startWorkTime }}</span>
        </td>
        <td>
          <span>{{ score?.endWorkTime }}</span>
        </td>
        <td>
          <span>{{ score?.totalShiftTime }}</span>
        </td>
        <td class="work w-7rem">
          <span>{{ score?.totalWorkTime }}</span>
        </td>
        <td class="pause w-7rem">
          <span>{{ score?.totalBreakTime }}</span>
        </td>
        <td class="off w-7rem">
          <span>{{ score?.totalLogoutTime }}</span>
        </td>
        <td class="work w-7rem">
          <span>{{ score?.totalWorkTimePercent }}%</span>
        </td>
        <td class="pause w-7rem">
          <span>{{ score?.totalBreakTimePercent }}%</span>
        </td>
        <td class="off w-7rem">
          <span>{{ score?.totalLogoutTimePercent }}%</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
